module.exports = __webpack_public_path__ + "img/jungle_2_TA.048bc220.png";